import styled from "styled-components";
import PropTypes from "prop-types";
import { desktopMarginsCutoff, overlayZ } from "../../styleConstants";
import SlideInHeader from "./SlideInHeader";
import SlideInContent from "./SlideInContent";
import SlideInFooter from "./SlideInFooter";

// this is the gray background on top of which the white slide slides in.
const GrayBack = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  // needs to be in front than navbar and navigation menus
  z-index: ${overlayZ};
  background: rgba(95, 95, 95, 0.75);
`;

// the white slide that slides into view. it will hold the header, contents, and footer.
const Slide = styled.div`
  border-top-left-radius: 32px;
  border-top-right-radius: 32px;

  // this makes it a column holding 3 elements, the header, contents, and footer.
  // only the middle section will be scrollable. the header and footer will be outside the scrollable area and will naturally sit on the top and bottom.
  display: flex;
  flex-direction: column;

  // hides weird white rectangle above corners of slide in.
  overflow: hidden;

  position: fixed;
  width: 100%;
  height: calc(100% - 18px);
  bottom: 0;
  background: white;

  animation: slide 0.5s ease;
  @keyframes slide {
    from {
      bottom: calc(-1 * (100% - 18px));
    }
    to {
      bottom: 0;
    }
  }

  // making a sideways slide in for wider screen widths.
  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    width: calc(min((100% - 50px), max(70%, 850px)));
    height: 100%;
    right: 0;

    @keyframes slide {
      from {
        right: calc(-1 * min((100% - 50px), max(70%, 850px)));
      }
      to {
        right: 0;
      }
    }
  }
`;

const SlideIn = ({ close, contents, footer }) => {
  return (
    <GrayBack>
      <Slide>
        <SlideInHeader close={close} />
        <SlideInContent contents={contents} />
        {footer && <SlideInFooter footer={footer} />}
      </Slide>
    </GrayBack>
  );
};

SlideIn.propTypes = {
  close: PropTypes.func,
  contents: PropTypes.element,
  footer: PropTypes.element,
};

export default SlideIn;
